import type { QueryKey } from '@tanstack/react-query';
import type { GetAllResidentsPhoenixParams } from './api';

export const RESIDENTS_PHOENIX_KEY = (
  nursingHomeId: string,
  params?: Omit<GetAllResidentsPhoenixParams, 'nursingHomeId'>
): QueryKey => ['residents-phoenix', nursingHomeId, params ?? {}];

export const SHOW_RESIDENT_KEY = (residentId: string): QueryKey => [
  'show-resident',
  residentId,
];
export const ALL_SHOW_RESIDENT_KEY = (): QueryKey => ['show-resident'];
